
<template>
  <div class="page">
    <v-container fluid>
      <v-form ref="form">
          <v-row class="d-flex justify-center mt-3">
            <v-col cols="3">
              <v-text-field
              label="Nome da Turma"
              v-model="form.filters.nomeTurma"
              outlined
              dense
              ></v-text-field>
            </v-col>
            <v-col cols="3">
              <v-autocomplete
                v-model="form.filters.anoSerie"
                label="Ano/Série"
                item-text="nome"
                item-value="id"
                outlined
                dense
                :items="form.lists.listAnoSeries"
              ></v-autocomplete>
            </v-col>
            <v-col cols="3">
              <v-autocomplete
                v-model="form.filters.turno"
                label="Turno"
                item-text="descricao"
                item-value="id"
                outlined
                dense
                :items="form.lists.listTurnos"
              ></v-autocomplete>
            </v-col>
          </v-row>
          <v-row class="d-flex justify-center mt-3">
            <v-col cols="3">
              <v-autocomplete
                v-model="form.filters.escola"
                label="Escola"
                item-text="local"
                item-value="id"
                outlined
                dense
                :items="form.lists.listEscolas"
              ></v-autocomplete>
            </v-col>
            <sca-date-picker
              :cols="2"
              label="Data Início"
              v-model="form.filters.dataInicio"
              removeIcon
              outlined
              dense
            ></sca-date-picker>
            <sca-date-picker
            :cols="2"
              v-model="form.filters.dataFim"
              label="Data Final"
              removeIcon
              outlined
              dense
            ></sca-date-picker>
          </v-row>
           <div class="text-center">
          <v-col cols="12">
            <sca-tooltip
              text="Buscar"
              icon="mdi-magnify"
              @click="buscarRelatorios"
            ></sca-tooltip>
            <sca-tooltip
              text="Limpar"
              icon="mdi-eraser"
              @click="resetForm"
            ></sca-tooltip>
          </v-col>
        </div>
      </v-form>
      <v-data-table
        class="mt-5 printable"
        :headers="headersAnalitico"
        :items="form.lists.listRelatorios"
        :items-per-page="10"
        :footer-props="$footerProps"
        sort-by="dataHora"
        :sort-desc="true"
        item-key="id"
      >
        <template v-slot:[`item.nomeTurma`]="{ item }">
          {{ item.nomeTurma }}
        </template>
        <template v-slot:[`item.anoSerie`]="{ item }">
          {{ item.anoSerie }}
        </template>
        <template v-slot:[`item.turno`]="{ item }">
          {{ item.turno }}
        </template>
        <template v-slot:[`item.escola`]="{ item }">
          {{ item.escola }}
        </template>
        <template v-slot:[`item.dataHora`]="{ item }">
          {{ item.dataHora }}
        </template>
        <template v-slot:[`item.acao`]="{ item }">
          {{ item.acao }}
        </template>
      </v-data-table>
      <sca-buttons
        v-if="form.lists.listRelatorios.length"
        actionText="Baixar PDF"
        cancelText="Baixar CSV"
        @click="baixarRelatorioPdf"
        @cancel="baixarCSVRelatorio"
      ></sca-buttons>
    </v-container>
  </div>
</template>

<script>
  import pageLoadingMixin from "mixins/page-loading.mixin";
  import RelatorioDeLog from "services/relatorios-log/manter-acompanhamento-turma.service";
  import SerieService from '~/services/serie.service';
  import TurnoService from '~/services/turno.service';
  import LotacaoService from '~/services/lotacao.service';
  export default {
      name: "RelatorioLogAcompanhamentoTurma",
      mixins: [pageLoadingMixin, RelatorioDeLog, SerieService, TurnoService, LotacaoService],

      data: () => ({
      onReport: false,
      expanded: [],
      form: {
          filters: {
              nomeTurma: null,
              anoSerie: null,
              turno: null,
              escola: null,
              dataInicio: null,
              dataFim: null,
          },
          lists: {
            listRelatorios: [],
            listAnoSeries: [],
            listTurnos: [],
            listEscolas: [],
          },
      },
      headersAnalitico: [
          { text: "Nome da Turma", align: "center", value: "nomeTurma" },
          { text: "Ano/Série", align: "center", value: "anoSerie" },
          { text: "Turno", align: "center", value: "turno"},
          { text: "Escola", align: "center", value: "escola"},
          { text: "Data/Hora da ação", align: "center", value: "dataHoraAcaoStr" },
          { text: "Ação", align: "center", value: "acao" },
      ],
      }),
      methods: {
      async buscarRelatorios() {
          const isValid = this.validarDatas();
          if (!isValid) return;
          if (!this.verificarFiltrosPreenchidos()) return;
          const filtros = { ...this.form.filters };
          this.showPageLoading();
          try {
          const { data } = await this.$obterRelatorioLogAcompanhamentoTurma({ params: filtros });
          this.processarRespostaRelatorio(data);
          } finally {
          this.hidePageLoading();
          }
      },
      validarDatas() {
      const { dataInicio, dataFim } = this.form.filters;

      if (dataInicio && dataFim) {
        if (new Date(dataFim) < new Date(dataInicio)) {
          this.$notifyWarning("A Data Final não pode ser anterior à Data Início");
          return false;
        }
        if (new Date(dataInicio) > new Date(dataFim)) {
          this.$notifyWarning("A Data Início não pode ser posterior à Data Final");
          return false;
        }
      }
      return true;
    },

    verificarFiltrosPreenchidos() {
      const { nomeTurma, anoSerie, turno, escola, dataInicio, dataFim } = this.form.filters;
      if (!nomeTurma && !anoSerie && !turno && !escola && !dataInicio && !dataFim) {
        this.$notifyWarning("Preencha pelo menos um filtro para retornar informações no relatório.");
        return false;
      }
      return true;
    },

      async baixarCSVRelatorio() {
        this.showPageLoading();
        try {
        const { data } = await this.$obterRelatorioLogCSVAcompanhamentoTurma({ params: this.form.filters });
        this.$baixarRelatorioCSV(data, `SCA.RelatórioDeLogDeAcompanhamentoTurmaCSV`);
        this.$notifySuccess("Operação realizada com sucesso.");
        } finally {
        this.hidePageLoading();
        }
      },

      async baixarRelatorioPdf() {
        this.showPageLoading();
        try {
        const { data } = await this.$obterRelatorioLogPDFAcompanhamentoTurma({ params: this.form.filters });
        const url = URL.createObjectURL(data);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "SCA.RelatórioDeLogDeAcompanhamentoTurma.pdf");
        document.body.appendChild(link);
        link.click();
        this.$notifySuccess("Operação realizada com sucesso.");
        } finally {
        this.hidePageLoading();
        }
      },

      processarRespostaRelatorio(data) {
        this.form.lists.listRelatorios = data.relatorio.lista;
      },

      resetForm() {
        this.form.filters.dataInicio = null;
        this.form.filters.dataFim = null;

        this.$nextTick(() => {
          this.$set(this.form.filters, 'dataInicio', null);
          this.$set(this.form.filters, 'dataFim', null);
        });
        this.form.filters.nomeTurma = null;
        this.form.filters.anoSerie = null;
        this.form.filters.turno = null;
        this.form.filters.escola = null;
        this.form.lists.listRelatorios = [];
      },
    },
    mounted() {
    this.$buscarSeries({ params: { ativo: true} }).then(({ data }) => (this.form.lists.listAnoSeries = data.itens));
    this.$buscarTurnos({ params: { ativo: true} }).then(({ data }) => (this.form.lists.listTurnos = data.itens));
    this.$buscarLotacoes({ params: { ativo: true, escola: true } }).then(({ data }) => {this.form.lists.listEscolas = data.resposta});
  }
  };
</script>
